import { callable } from './callable'

export interface DeleteWorkspaceInput {
  workspaceId: string
}

export interface DeleteWorkspaceResult {
  ok: true
  workspaceId: string
  refundedCredits?: number
  purgeAfter?: unknown
  requestedAt?: unknown
  deletedCounts?: {
    keyedDocs: number
    mirrors: number
    docIdDocs: number
  }
}

export interface RequestWorkspaceDeletionInput {
  workspaceId: string
}

export interface RequestWorkspaceDeletionResult {
  ok: true
  workspaceId: string
  purgeAfter: unknown
  requestedAt: unknown
}

export interface RestoreWorkspaceDeletionInput {
  workspaceId: string
}

export interface RestoreWorkspaceDeletionResult {
  ok: true
  workspaceId: string
}

export const deleteWorkspace = async (input: DeleteWorkspaceInput): Promise<DeleteWorkspaceResult> => {
  return callable<DeleteWorkspaceInput, DeleteWorkspaceResult>('deleteWorkspace', input)
}

export const requestWorkspaceDeletion = async (
  input: RequestWorkspaceDeletionInput,
): Promise<RequestWorkspaceDeletionResult> => {
  return callable<RequestWorkspaceDeletionInput, RequestWorkspaceDeletionResult>(
    'requestWorkspaceDeletion',
    input,
  )
}

export const restoreWorkspaceDeletion = async (
  input: RestoreWorkspaceDeletionInput,
): Promise<RestoreWorkspaceDeletionResult> => {
  return callable<RestoreWorkspaceDeletionInput, RestoreWorkspaceDeletionResult>(
    'restoreWorkspaceDeletion',
    input,
  )
}
